// TODO: simplify
import { FC, useEffect, useRef, useState } from 'react'
import { clickCollectPOST } from 'featureSliced/shared/api/clickCollect/POST'
import { DataTrans } from '../../../components/Checkout/DataTrans'
import { Input } from '../../../components/Input'
import { RadioContainer, RefillCard, ResultText } from './styled'
import { Radio } from '../../../components/Radio/styled'
import Auth from '@aws-amplify/auth'
import { CCProvider } from '../../shared/utils/getCCProviderIcon'
import { errorHandler } from '../../../components/ErrorHandler'
import { useSearchParams } from 'react-router-dom'
import { convertToPrice } from '../../shared/utils/convertToPrice'
import { clickCollectGET } from 'featureSliced/shared/api/clickCollect/GET'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { RenderIf } from 'components/RenderIf'
import { Spinner } from 'featureSliced/entities/Spinner'
import { CheckBox } from 'featureSliced/entities/CheckBox'
import { Button } from 'featureSliced/entities/Button'
import { openLink } from 'featureSliced/shared/utils/openLink'
import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { useAdyen } from 'featureSliced/shared/hooks/useAdyen/useAdyen'
import { AdyenPaymentInitType } from 'featureSliced/shared/api/qrMenu/types'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { ToastsSlice } from 'featureSliced/shared/store/reducers/ToasterReducer'

type FeeSetting = {
  from: number
  to: number
  percentage: number
}

type RefillCardModalProps = {
  isWallet?: boolean
  feeDetailsProps?: FeeSetting[] | null
  onClose: () => void
}

export const RefillCardModal: FC<RefillCardModalProps> = ({
  isWallet,
  feeDetailsProps,
  onClose,
}) => {
  // Hooks
  const t = useTranslations()
  const startAdyen = useAdyen()
  const [searchParams, setSearchParams] = useSearchParams()

  const dispatch = useMyDispatch()

  // Store
  const openToast = ToastsSlice.actions.openToast
  const isUserAuth = useMySelector((state) => state.auth.isLoggedIn)
  const { DatatransActivated, Currency } = useMySelector((state) => {
    return state.app.companyData
  })
  const paymentProvider = useMySelector(
    (state) => state.app.paymentConfig?.paymentProviderType
  )
  const adyenShopId = useMySelector(
    (state) => state.app.paymentConfig?.hsPay?.shopId
  )
  const walletCardId = searchParams.get('walletCardId')

  // State
  const [refillValue, setRefillValue] = useState('')
  const [tipsValue, setTipsValue] = useState(0)
  const [paymentId, setPaymentId] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  // saved card State
  const [userCardData, setUserCardData] = useState<any>()
  const [useSavedCard, setUseSavedCard] = useState<boolean>(false)
  const [updateActiveCard, setUpdateActiveCard] = useState(false)
  const [feeDetails, setFeeDetails] = useState<FeeSetting[]>()
  const [isFeeDetailsLoading, setIsFeeDetailsLoading] = useState<boolean>(false)

  //useEffect
  useEffect(() => {
    initUserData()
  }, [])

  useEffect(() => {
    getFeeDetails()
  }, [feeDetailsProps])

  useEffect(() => {
    const initFee = feeDetails?.filter((el) => el.percentage)?.[0]
    setRefillValue(convertToPrice(initFee?.from?.toString() || ''))
    setTipsValue(initFee?.percentage || 0)
  }, [feeDetails])

  // Functions
  const handleSetUseSavedCard = (value: boolean) => {
    setUseSavedCard((prevValue) => {
      if (!prevValue) {
        setUpdateActiveCard(false)
      }
      return !prevValue
    })
  }

  const getFeeDetails = async () => {
    if (feeDetailsProps) {
      setFeeDetails(feeDetailsProps)
    } else {
      try {
        setIsFeeDetailsLoading(true)
        const details = await clickCollectGET.cardDetails()
        setFeeDetails(details?.settings)
      } catch (e) {
        console.log('Error:', e)
      } finally {
        setIsFeeDetailsLoading(false)
      }
    }
  }

  const initUserData = async () => {
    if (isUserAuth && paymentProvider !== 3) {
      const currentUserInfo = await Auth.currentUserInfo()
      const attributes = currentUserInfo?.attributes
      if (attributes?.['custom:active_card_token']) {
        setUserCardData(JSON.parse(attributes?.['custom:active_card_token']))
        setUseSavedCard(true)
      }
    }
    setIsLoading(false)
  }

  const handleInputChange = (e: any) => {
    const value = Number(e.currentTarget.value)
    if (!isNaN(value)) {
      setRefillValue(e.target.value?.replace(/\.(\d{1,2}).*$/, '.$1'))
      const fee = feeDetails?.find((el) => {
        const isGreaterThanFrom = el.from <= value || !el.from
        const isLowerThanTo = el.to >= value || !el.to
        return isGreaterThanFrom && isLowerThanTo
      })
      setTipsValue(fee?.percentage || 0)
    }
  }

  const refill = async () => {
    if (refillValue && (DatatransActivated || paymentProvider === 3)) {
      try {
        setIsLoading(true)
        const startRefill = async (shopId?: string, hsPaymentData?: any) => {
          const result = await clickCollectPOST.refillCardRequest(
            +refillValue,
            !useSavedCard,
            updateActiveCard,
            shopId,
            hsPaymentData
          )

          // TODO: isnt dry. is also used in usePayment
          const hasIpr =
            result !== null &&
            typeof result === 'object' &&
            'InitPaymentResult' in result

          const ipr = hasIpr
            ? (result as AdyenPaymentInitType).InitPaymentResult
            : undefined

          return {
            ...result,
            paymentKey: ipr?.paymentKey,
            resultCode:
              ipr?.resultCode || ipr?.paymentKey ? 'Authorised' : 'Error',
            action: ipr?.action,
          }
        }
        let result
        if (paymentProvider === 3 && adyenShopId?.length) {
          result = startAdyen(
            Math.round(+refillValue * 100),
            async (hsPaymentData: any) =>
              startRefill(adyenShopId, hsPaymentData),
            async (transactionId: string | null) =>
              completeCardRefill(transactionId, null)
          )
        } else {
          if (isWallet) {
            result = await clickCollectPOST.refillCardRequestWallet(
              +refillValue,
              walletCardId || ''
            )
          } else {
            result = startRefill()
          }
          if (result.PaymentProvider === 1) {
            if (result.PaymentType === 'default') {
              setPaymentId(result?.TransactionId)
            }
            if (result.PaymentType === 'init') {
              setPaymentId(result?.TransactionId)
            }
            if (result.PaymentType === 'savedCard') {
              completeCardRefill(result?.TransactionId, null)
            }
            if (result.PaymentType === 'authorize') {
              completeCardRefill(result?.TransactionId, null)
            }
          }
          // SaferPay is not supported so far
          if (result.PaymentProvider === 2) {
            if (result.PaymentType === 'default' && result?.RedirectUrl) {
              openLink(result.RedirectUrl)
            }
            if (result.PaymentType === 'savedCard') {
              completeCardRefill(null, result?.TransactionId)
            }
          }
        }
      } catch (e) {
        errorHandler(e)
      } finally {
        // setIsLoading(true)
      }
    }
  }

  // TODO: isnt dry. is also used in useAdyen
  const completeCardRefill = async (
    datatransTrxId: string | null,
    orderGuid: string | null
  ) => {
    try {
      setIsLoading(true)
      const success = await clickCollectPOST.refillCardComplete(
        datatransTrxId,
        orderGuid
      )

      if (success) {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        onClose?.()
      }
      searchParams.delete('show_card')
      searchParams.delete('orderGuid')
      searchParams.delete('datatransTrxId')
      setSearchParams(searchParams)
    } catch (e) {
      dispatch(
        openToast({
          // TODO: translations
          message: t('common.somethingWentWrong'),
          type: 'error',
        })
      )
    } finally {
      setIsLoading(false)
    }
  }

  const addPercentage = (value: number, percentage: number) => {
    return convertToPrice(
      (value + value * (percentage / 100))
        ?.toString()
        ?.replace(/\.(\d{1,2}).*$/, '.$1')
    )
  }

  return (
    <RefillCard>
      <RenderIf condition={!!paymentId}>
        <DataTrans transactionId={paymentId as string} />
      </RenderIf>
      <RenderIf condition={isFeeDetailsLoading}>
        <Spinner type="transparent" />
      </RenderIf>
      {feeDetails
        ?.filter((el) => el.percentage)
        ?.map((el) => {
          return (
            <RadioContainer key={el.from}>
              <Radio
                type="radio"
                id="useNew"
                name="card"
                value={el.from}
                checked={
                  convertToPrice(refillValue) === convertToPrice(el.from)
                }
                onChange={handleInputChange}
                disabled={isLoading}
              />
              <label htmlFor="useNew">
                {t('profile.percentageForAmount', {
                  percentage: el.percentage,
                  currency: Currency,
                  amount: convertToPrice(el.from),
                })}
              </label>
            </RadioContainer>
          )
        })}
      <Input
        inputMode="numeric"
        onChange={handleInputChange}
        value={refillValue}
        disabled={isLoading}
      />
      <ResultText>
        {t('cover.payGetLoaded', {
          v1: refillValue || 0,
          v2: addPercentage(+refillValue, tipsValue),
        })}
      </ResultText>

      <RenderIf
        condition={isUserAuth && !!userCardData && paymentProvider !== 3}
      >
        <CheckBox
          isDisabled={isLoading}
          isChecked={useSavedCard}
          onClick={handleSetUseSavedCard}
          label={
            <span>
              <span>{t('selfService.useSavedCard')}</span>
              {' ( '}
              <CCProvider cardMask={userCardData?.masked} />{' '}
              <span>
                {t('selfService.withEnding')}{' '}
                {userCardData?.masked?.split('x').pop()}
                {' )'}
              </span>
            </span>
          }
        />
        <br />
        <RenderIf condition={!useSavedCard}>
          <CheckBox
            isChecked={updateActiveCard}
            onClick={setUpdateActiveCard}
            label={t('selfService.newCardAsDefault')}
            isDisabled={useSavedCard || isLoading}
          />
        </RenderIf>
        <RenderIf condition={useSavedCard}>
          <div style={{ height: '28px' }} />
        </RenderIf>
        <br />
      </RenderIf>
      <RenderIf condition={paymentProvider === 3}>
        <CheckBox
          isChecked={updateActiveCard}
          onClick={setUpdateActiveCard}
          label={t('selfService.newCardAsDefault')}
        />
        <div style={{ height: '28px' }} />
      </RenderIf>
      <Button
        buttonType="common"
        width="100%"
        onClick={refill}
        disabled={
          !refillValue || !(DatatransActivated || paymentProvider === 3)
        }
        isLoading={isLoading}
      >
        {t('cover.pay')}
      </Button>
    </RefillCard>
  )
}
